const SDK_URL = 'https://accounts.google.com/gsi/client';
let loading = null;

export const loadGoogleIdentity = () => {
  if (window.google?.accounts?.id) return Promise.resolve(window.google.accounts.id);
  if (loading) return loading;

  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SDK_URL;
    script.async = true;
    const finish = (error) => {
      clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      if (error) {
        script.remove();
        reject(error);
      } else {
        resolve(window.google.accounts.id);
      }
    };
    const timeout = setTimeout(() => finish(new Error('Google sign-in took too long to load. Use password login or retry.')), 15000);
    script.onload = () => finish(window.google?.accounts?.id ? null : new Error('Google sign-in could not be loaded. Use password login or retry.'));
    script.onerror = () => finish(new Error('Google sign-in could not be loaded. Check your connection or use password login.'));
    document.head.appendChild(script);
  }).catch((error) => {
    loading = null;
    throw error;
  });
  return loading;
};
